<template>
  <div>
    <div class="page-content">
      <Row :gutter="30">
        <Col :span="17">
          <Row :gutter="30">
            <Col :span="6">
              <div class="page-box">
                <div class="page-box-content" style="height: 360px">
                  <div class="scoped-title">{{ $t('name.cex.title.cex') }}</div>
                  <Cascader v-model="cex_value" :data="cex" @on-change="(value, data) => { this.id = value[1]; this.change = data[1]; this.$refs.order.get() }" />
                  <div class="scoped-content">{{ change.content }}</div>
                </div>
              </div>
            </Col>
            <Col :span="18">
              <div class="page-box">
                <div class="page-box-content">
                  <div class="scoped-title">{{ $t('name.cex.title.bultos') }}</div>
                  <Form ref="form" :model="form" :rules="rule">
                    <Row :gutter="20">
                      <Col :span="8">
                        <FormItem :label="$t('name.cex.bultos')" prop="bultos">
                          <div style="display: inline-block; width: 100%;">
                            <InputNumber v-model="form.numBultos" :min="0" :precision="0" style="width: 100%" />
                          </div>
                        </FormItem>
                      </Col>
                      <Col :span="8">
                        <FormItem :label="$t('name.cex.kilos')" prop="kilos">
                          <div style="display: inline-block; width: 100%;">
                            <InputNumber v-model="form.kilos" :min="0" @on-change="$refs.order.get()" style="width: 100%" />
                          </div>
                        </FormItem>
                      </Col>
                      <Col :span="8">
                        <Button type="primary" ghost style="margin-top: 34px" @click="$refs.tool.open()">{{ $t('name.cex.button_tool') }}</Button>
                        <Tool ref="tool" :bultos.sync="form.numBultos" :kilos.sync="form.kilos" @add="$refs.order.get()" :cex="change" />
                      </Col>
                    </Row>
                    <Row :gutter="20">
                      <Col :span="8">
                        <FormItem :label="$t('name.cex.seguro')">
                          <div style="display: inline-block; width: 100%;">
                            <InputNumber v-model="form.seguro" :min="0" @on-change="$refs.order.get()" style="width: 100%" />
                          </div>
                        </FormItem>
                      </Col>
                      <Col :span="8">
                        <FormItem :label="$t('name.cex.reembolso')">
                          <div style="display: inline-block; width: 100%;">
                            <InputNumber v-model="form.reembolso" :min="0" @on-change="$refs.order.get()" style="width: 100%" />
                          </div>
                        </FormItem>
                      </Col>
                      <Col :span="8">
                        <FormItem :label="$t('name.cex.take')">
                          <Select v-model="form.take">
                            <Option value="N">{{ $t('name.cex.take_text.n') }}</Option>
                            <Option value="S">{{ $t('name.cex.take_text.s') }}</Option>
                          </Select>
                        </FormItem>
                      </Col>
                    </Row>
                    <Row :gutter="20">
                      <Col :span="8">
                        <FormItem :label="$t('name.cex.refCliente')">
                          <Input v-model="form.refCliente" />
                        </FormItem>
                      </Col>
                      <Col :span="16">
                        <FormItem :label="$t('name.cex.observac')">
                          <Input v-model="form.observac" />
                        </FormItem>
                      </Col>
                    </Row>
                  </Form>
                </div>
              </div>
            </Col>
          </Row>
          <Address ref="sender"  :title="$t('name.cex.title.sender')" />
          <Address ref="receive" :title="$t('name.cex.title.receive')" />
        </Col>
        <Col :span="7">
          <div class="page-box">
            <div class="page-box-content" style="height: 915px">
              <Order ref="order" :id="id" :form="form" @order="onOrder" />
              <List ref="list" />
            </div>
          </div>
        </Col>
      </Row>
    </div>
  </div>
</template>
<script>
import Tool from './tool'
import Order from './order'
import List from './list'
import Address from '../address/address'
import app from '@/tools'
import { get } from '@/api/cex'

export default {
  components: {
    Tool,
    Order,
    List,
    Address
  },
  data() {
    return {
      cex: [],
      cex_value: [],
      id: 0,
      change: {},
      form: {
        numBultos: 0,
        kilos: 0,
        seguro: 0,
        reembolso: 0,
        take: 'N',
        refCliente: app.user().number
      },
      rule: {
        numBultos: [
          { required: true, type: 'number', message: ' ', trigger: 'blur' }
        ],
        kilos: [
          { required: true, type: 'number', message: ' ', trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    // 首次获取线路
    get().then(res => {
      // 整理线路
      const handle = (data) => {
        return data.map(item => {
          return {
            value: item.id,
            label: item.name,
            children: item.cex ? handle(item.cex) : [],
            disabled: item.status !== undefined ? !item.status : false,
            ...item,
          }
        })
      }
      this.cex = handle(res)
      this.cex_value = [res[0].id, res[0].cex[0].id]
      this.change = res[0].cex[0]
      this.id = this.change.id
      
      // 首次更新价格
      this.$refs.order.get()
    })
  },
  methods: {
    // 下单
    async onOrder(type) {
      // 获取地址信息
      const sender = await this.$refs.sender.get()
      if(!sender) return
      
      // 获取收件
      const receive = await this.$refs.receive.get()
      if(!receive) return
      
      // 准备数据
      this.form = Object.assign(this.form, {
        // 发件人
        nomRte: sender.name,
        telefRte: sender.phone,
        dirRte: sender.address + ' ' + sender.number + (sender.house ? ', ' + sender.house : ''),
        pobRte: sender.city,
        codPosNacRte: sender.zip,
        
        // 收件人名称
        nomDest: receive.name,
        telefDest: receive.phone,
        dirDest: receive.address + ' ' + receive.number + (receive.house ? ', ' + receive.house : ''),
        pobDest: receive.city,
        codPosNacDest: receive.zip,
      })
      
      // 开始下单
      const order = await this.$refs.order.start()
      if(!order) return
      
      // 更新收发件人
      this.$refs.sender.put()
      this.$refs.receive.put()
      
      // 控制列表
      if(type) {
        // 直接确认订单
        this.$refs.list.ok(order.id)
      } else {
        // 只刷新列表
        this.$refs.list.getPay()
      }
    }
  },
};
</script>
<style lang="less" scoped>
  @import '@/style/app.less';
  
  .scoped-title{
    color: @color-content;
    font-size: 18px;
    line-height: 30px;
    padding-bottom: 15px;
  }
  
  .scoped-content{
    margin-top: 20px;
    background: @background;
    color: @color-sub;
    font-size: 14px;
    line-height: 30px;
    padding: 15px 20px;
  }
  
  .scoped-order{
    padding-bottom: 25px;
    text-align: center;

    .money{
      color: @color-content;
      font-size: 20px;
      line-height: 30px;
      
      &.color{
        color: @color;
      }
    }
    
    .title{
      color: @color-sub;
      font-size: 14px;
      line-height: 25px;
    }
  }
</style>